import { useState, FormEvent } from "react";

const FORM_URL = "https://readdy.ai/api/form/d7brdv0fgr5j5eoavcpg";

export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const form = e.currentTarget;
    const data = new URLSearchParams();
    const formData = new FormData(form);
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });

    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      if (res.ok) {
        setSubmitted(true);
      } else {
        setError("Ошибка отправки. Пожалуйста, попробуйте ещё раз.");
      }
    } catch {
      setError("Ошибка сети. Пожалуйста, попробуйте ещё раз.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="bg-[#080C14] py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Left: Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-[2px] bg-[#C9A84C]"></div>
              <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">Контакты</span>
            </div>
            <h2 className="text-white mb-6" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(32px, 4vw, 56px)", letterSpacing: "0.03em" }}>
              ЗАПРОСИТЬ<br />
              <span className="text-[#C9A84C]">B2B ПРАЙС-ЛИСТ</span>
            </h2>
            <p className="text-gray-400 text-base leading-relaxed mb-10">
              Заполните форму — наш менеджер свяжется с вами в течение 24 часов. Мы предоставим актуальный B2B прайс-лист с ценами на все позиции: MERCEDES-BENZ, BMW, VAG, JLR и масла Shell. 100% «белая» таможня, ГТД/НДС, Честный ЗНАК.
            </p>

            {/* Contact Details */}
            <div className="flex flex-col gap-5 mb-10">
              {[
                { icon: "ri-building-2-line", label: "Россия", value: "ООО «ЯСИН РУС» · Москва" },
                { icon: "ri-building-line", label: "Китай", value: "YAXIN LIANPEI · Гуанчжоу" },
                { icon: "ri-ship-line", label: "Экспорт", value: "GUANGZHOU CHIRUN · Гуанчжоу" },
                { icon: "ri-shield-check-line", label: "Сертификация", value: "EAC · Честный ЗНАК · ГТД/НДС" },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center border border-[#C9A84C]/30 rounded-sm flex-shrink-0">
                    <i className={`${item.icon} text-[#C9A84C] text-base`}></i>
                  </div>
                  <div>
                    <div className="text-gray-500 text-xs uppercase tracking-wide">{item.label}</div>
                    <div className="text-white text-sm font-medium">{item.value}</div>
                  </div>
                </div>
              ))}
              {/* Direct contacts — MAX */}
              <div className="pt-2 border-t border-[#1E2A3A]">
                <div className="text-[#C9A84C] text-xs font-semibold tracking-[0.2em] uppercase mb-3">Прямой контакт · MAX</div>
                <div className="flex flex-col gap-3">
                  {/* Email — recommended */}
                  <a href="mailto:eagle_parts@vk.com" className="flex items-start gap-3 group cursor-pointer">
                    <div className="w-10 h-10 flex items-center justify-center border border-[#C9A84C]/30 group-hover:border-[#C9A84C] rounded-sm flex-shrink-0 transition-colors mt-0.5">
                      <i className="ri-mail-line text-[#C9A84C] text-base"></i>
                    </div>
                    <div>
                      <div className="flex items-center gap-2">
                        <div className="text-gray-500 text-xs uppercase tracking-wide">Email</div>
                        <span className="text-[9px] font-bold text-[#0A0F1A] bg-[#C9A84C] px-1.5 py-0.5 rounded-sm uppercase tracking-wide">Рекомендуем</span>
                      </div>
                      <div className="text-white text-sm font-medium group-hover:text-[#C9A84C] transition-colors">eagle_parts@vk.com</div>
                      <div className="text-gray-600 text-xs mt-0.5">Учитывайте разницу часовых поясов — email быстрее</div>
                    </div>
                  </a>
                  {/* Telegram — MAX (no phone, text only) */}
                  <a href="https://t.me/MAX_YAXIN" target="_blank" rel="nofollow noopener noreferrer" className="flex items-start gap-3 group cursor-pointer">
                    <div className="w-10 h-10 flex items-center justify-center border border-[#C9A84C]/30 group-hover:border-[#C9A84C] rounded-sm flex-shrink-0 transition-colors mt-0.5">
                      <i className="ri-telegram-line text-[#C9A84C] text-base"></i>
                    </div>
                    <div>
                      <div className="flex items-center gap-2">
                        <span className="text-[#C9A84C] text-[9px] font-black tracking-widest uppercase border border-[#C9A84C]/40 px-1 py-0.5 rounded-sm">MAX</span>
                        <div className="text-gray-500 text-xs uppercase tracking-wide">Telegram</div>
                      </div>
                      <div className="text-white text-sm font-medium group-hover:text-[#C9A84C] transition-colors">@MAX_YAXIN</div>
                      <div className="text-gray-600 text-xs mt-0.5">Только текстовые сообщения. Голосовые вызовы не принимаются.</div>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            {/* Trilingual Contract Badge */}
            <div className="bg-[#0D1420] border border-[#C9A84C]/20 p-5 rounded-sm">
              <div className="text-[#C9A84C] text-xs font-semibold tracking-[0.2em] uppercase mb-2">Трёхъязычный контракт</div>
              <p className="text-gray-400 text-sm leading-relaxed">
                Мы работаем на основе стандартного контракта на трёх языках: <strong className="text-white">Китайском, Английском и Русском</strong>. Полная юридическая прозрачность для ваших банков.
              </p>
            </div>
          </div>

          {/* Right: Form */}
          <div className="bg-[#0D1420] border border-[#1E2A3A] p-8 rounded-sm">
            {submitted ? (
              <div className="flex flex-col items-center justify-center h-full min-h-[400px] text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-[#C9A84C]/10 border border-[#C9A84C]/40 rounded-full mb-6">
                  <i className="ri-check-line text-[#C9A84C] text-3xl"></i>
                </div>
                <h3 className="text-white font-bold text-xl mb-3" style={{ fontFamily: "'Oswald', sans-serif" }}>Запрос отправлен!</h3>
                <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
                  Наш менеджер свяжется с вами в течение 24 часов и предоставит актуальный B2B прайс-лист.
                </p>
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-5">
                <div>
                  <div className="text-[#C9A84C] text-xs font-semibold tracking-[0.2em] uppercase mb-4">Запрос B2B прайс-листа</div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-gray-400 text-xs uppercase tracking-wide mb-1.5">Имя *</label>
                    <input
                      type="text"
                      name="name"
                      required
                      placeholder="Иван Петров"
                      className="w-full bg-[#080C14] border border-[#1E2A3A] text-white text-sm px-4 py-3 rounded-sm focus:outline-none focus:border-[#C9A84C]/60 placeholder-gray-600 transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-400 text-xs uppercase tracking-wide mb-1.5">Компания *</label>
                    <input
                      type="text"
                      name="company"
                      required
                      placeholder="ООО Автодетали"
                      className="w-full bg-[#080C14] border border-[#1E2A3A] text-white text-sm px-4 py-3 rounded-sm focus:outline-none focus:border-[#C9A84C]/60 placeholder-gray-600 transition-colors"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-gray-400 text-xs uppercase tracking-wide mb-1.5">Email *</label>
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="ivan@company.ru"
                      className="w-full bg-[#080C14] border border-[#1E2A3A] text-white text-sm px-4 py-3 rounded-sm focus:outline-none focus:border-[#C9A84C]/60 placeholder-gray-600 transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-400 text-xs uppercase tracking-wide mb-1.5">Телефон / WhatsApp</label>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="+7 (999) 000-00-00"
                      className="w-full bg-[#080C14] border border-[#1E2A3A] text-white text-sm px-4 py-3 rounded-sm focus:outline-none focus:border-[#C9A84C]/60 placeholder-gray-600 transition-colors"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-gray-400 text-xs uppercase tracking-wide mb-1.5">Интересующие марки *</label>
                  <select
                    name="brands"
                    required
                    className="w-full bg-[#080C14] border border-[#1E2A3A] text-white text-sm px-4 py-3 rounded-sm focus:outline-none focus:border-[#C9A84C]/60 transition-colors cursor-pointer"
                  >
                    <option value="">Выберите марку</option>
                    <option value="Mercedes-Benz">Mercedes-Benz</option>
                    <option value="BMW">BMW</option>
                    <option value="VAG (Audi/VW/Porsche)">VAG (Audi / VW / Porsche)</option>
                    <option value="Jaguar Land Rover">Jaguar Land Rover</option>
                    <option value="Shell Oils HK">Масла Shell (Гонконг)</option>
                    <option value="Все марки">Все марки + Shell</option>
                  </select>
                </div>

                <div>
                  <label className="block text-gray-400 text-xs uppercase tracking-wide mb-1.5">Регион поставки</label>
                  <input
                    type="text"
                    name="region"
                    placeholder="Москва / Екатеринбург / Новосибирск..."
                    className="w-full bg-[#080C14] border border-[#1E2A3A] text-white text-sm px-4 py-3 rounded-sm focus:outline-none focus:border-[#C9A84C]/60 placeholder-gray-600 transition-colors"
                  />
                </div>

                <div>
                  <label className="block text-gray-400 text-xs uppercase tracking-wide mb-1.5">Комментарий / Артикулы OE</label>
                  <textarea
                    name="message"
                    rows={3}
                    maxLength={500}
                    placeholder="Укажите интересующие артикулы OE или объём закупки..."
                    className="w-full bg-[#080C14] border border-[#1E2A3A] text-white text-sm px-4 py-3 rounded-sm focus:outline-none focus:border-[#C9A84C]/60 placeholder-gray-600 transition-colors resize-none"
                  />
                </div>

                {error && (
                  <div className="text-red-400 text-sm bg-red-400/10 border border-red-400/20 px-4 py-3 rounded-sm">
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="flex items-center justify-center gap-3 bg-[#C9A84C] hover:bg-[#b8943d] disabled:opacity-60 text-[#0A0F1A] font-bold text-sm px-8 py-4 rounded-sm tracking-wide uppercase transition-colors whitespace-nowrap cursor-pointer"
                >
                  {loading ? (
                    <><i className="ri-loader-4-line animate-spin text-base"></i> Отправка...</>
                  ) : (
                    <><i className="ri-file-list-3-line text-base"></i> Запросить B2B прайс-лист</>
                  )}
                </button>

                <p className="text-gray-600 text-xs text-center">
                  Трёхъязычный контракт (КНР · EN · RU) · Белая таможня · ГТД/НДС · Честный ЗНАК
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
